@if (complementary.error()) {
  <ideal-error [error]="complementary.error()"></ideal-error>
} @else {
  <ideal-product-result-list [ids]="complementaryIds()" view="grid"></ideal-product-result-list>
}
